<template>
  <div class="location grid cols-3">
    <div class="form-group">
      <label for="">Departamento</label>
      <select class="form-control" v-model="idDepartamento">
        <option value="0">Seleccione</option>
        <option v-for="item in departamentos" :value="item.id">{{ item.nombre }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="">Provincia</label>
      <select class="form-control" v-model="idProvincia">
        <option value="0">Seleccione</option>
        <option v-for="item in provincias" :value="item.id">{{ item.nombre }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="">Municipio</label>
      <select class="form-control" v-model="idMunicipio">
        <option value="0">Seleccione</option>
        <option v-for="item in municipios" :value="item.id">{{ item.nombre }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.getDepartamentos();
  },
  data () {
    return {
      departamentos: [],
      provincias: [],
      municipios: [],
      idDepartamento: 0,
      idProvincia: 0,
      idMunicipio: 0
    };
  },
  methods: {
    getDepartamentos () {
      this.$service.get('departamentos')
      .then(response => {
        this.departamentos = response;
      });
    },
    getProvincias (idDepartamento) {
      this.idProvincia = 0;
      this.idMunicipio = 0;
      this.provincias = [];
      this.municipios = [];
      this.$service.get(`provincias/${idDepartamento}`)
      .then(response => {
        this.provincias = response;
      });
    },
    getMunicipios (idProvincia) {
      this.idMunicipio = 0;
      this.municipios = [];
      this.$service.get(`municipios/${idProvincia}`)
      .then(response => {
        this.municipios = response;
      });
    }
  },
  watch: {
    idDepartamento: function (val) {
      this.getProvincias(val);
    },
    idProvincia: function (val) {
      this.getMunicipios(val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/util/Location.vue